import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { SpinnerService } from 'app/services/spinner.service';
import { AuthService } from 'app/services/auth.service';
import { PaymentService } from 'app/services/payment.service';

@Component({
  selector: 'app-bill-detail',
  templateUrl: './bill-detail.component.html',
  styleUrls: ['./bill-detail.component.css'],
})

export class BillDetailComponent implements OnInit {

  submitted = false;
  error = false;
  file_error = false;
  file_message = '';
  success = false;
  dataJSON: any;
  adminUser: Boolean = false;
  documentDetail: any = null;
  billForm: FormGroup;
  uploadedFile: any;
  base64Content: any;
  lastUploadedDoc: any = null;

  billPaymentId = '';
  paymentData: any;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private spinnerService: SpinnerService,
    private commonUtilService: CommonUtilService,
    private authService: AuthService,
    private paymentService: PaymentService) {

    this.adminUser = this.authService.isAdmin();
  }

  ngOnInit() {

    this.spinnerService.start();

    this.commonUtilService.translateLang("HRWE.PAGE_TITLE.BILL_PAYMENT_DETAIL");

    this.billPaymentId = this.route.snapshot.paramMap.get('id');

    this.billForm = this.createAssistenzaFormBuilder(this.formBuilder);

    this.paymentService.getBillPaymentById(this.billPaymentId).subscribe(data => {
      /* console.log(data); */
      if (data) {
        this.paymentData = data;
        this.lastUploadedDoc = data.noticeFile;

        /* console.log(this.lastUploadedDoc); */
      }
      this.spinnerService.stop();
    });
  }

  createAssistenzaFormBuilder(formBuilder: FormBuilder) {
    return formBuilder.group({
      attachment: ['', [Validators.required]]
    })
  }

  get f() { return this.billForm.controls; }

  get val() { return this.billForm.value; }

  onSubmit() {
    this.submitted = true;

    if (this.billForm.invalid) {
      this.commonUtilService.findInvalidControls(this.billForm);
      return;
    }

    this.spinnerService.start();

    this.dataJSON = {
      fileName: this.uploadedFile.name,
      type: this.uploadedFile.type,
      size: this.uploadedFile.size,
      extension: this.uploadedFile.name.split('.').pop(),
      domain: null,
      userId: null,
      base64: this.base64Content,
      code: null,
      message: null
    }

    /* console.log(this.dataJSON); */
    this.paymentService.uploadDocument(this.billPaymentId, this.dataJSON).subscribe(() => {
      this.success = true;
      this.spinnerService.stop();
      this.goBack();
    },
      () => {
        this.error = true;
        this.spinnerService.stop();
      }
    );
  }

  goBack() {
    this.router.navigate(['/consumption/bill']);
  }

  onFileChange(event, field, extension?) {
    const reader = new FileReader();
    if (event.target.files.length > 0) {
      this.file_error = false;
      this.file_message = '';
      this.uploadedFile = event.target.files[0];
      if (!extension || this.commonUtilService.enabledExtension(this.uploadedFile, extension)) {
        reader.readAsDataURL(this.uploadedFile);
        reader.onload = () => {
          let kb = this.uploadedFile.size / 1024;
          let mb = kb / 1024;
          let sizeParsed = parseFloat(mb.toString());
          if (sizeParsed > CommonUtilService.LIMIT_SIZE_MB) {
            this.file_error = true;
            this.billForm.get(field).setValue(undefined);
            return;
          }
          this.base64Content = this.commonUtilService.getBase64FromFile(reader.result);
          this.billForm.get(field).setValue({
            name: this.uploadedFile.name,
            filetype: this.uploadedFile.type,
            fileBinary: reader.result
          });
        };
      } else {
        this.file_message = CommonUtilService.FILE_BAD_EXTENSION;
        this.file_error = true;
        this.billForm.get(field).setValue(undefined);
        return;
      }
    }
  }

  getAttachmentFile(name, fileBinary) {
    this.commonUtilService.downloadFile(name, fileBinary, true);
    return false;
  }

}